export const PERSIST_ENTERED_INFO = 'PERSIST_ENTERED_INFO'
export const SET_DEALS_INVOICE = 'SET_DEALS_INVOICE'
